import RatingStamp from "./RatingStamp";
import Button from "./Button";
import styles from "./ProviderCard.module.css";

export default function ProviderCard({ name, trade, pincode, rating, phone, verified, onReview }) {
  return (
    <article className={styles.card}>
      <header className={styles.head}>
        <div>
          <h3 className={styles.name}>{name}</h3>
          <div className={styles.chips}>
            {trade && <span className={styles.chip}>{trade}</span>}
            {pincode && <span className={styles.chip}>{pincode}</span>}
          </div>
        </div>
        <RatingStamp value={rating} />
      </header>
      {verified && <p className={styles.verified}>✓ Verified pro</p>}
      {phone && <p className={styles.phone}>{phone}</p>}
      {onReview && (
        <Button variant="secondary" onClick={onReview}>
          Rate &amp; review
        </Button>
      )}
    </article>
  );
}
